import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { Link } from "react-router-dom";

export default function PiicPathwayNav() {
  return (
    <section className="bg-tie-teal/5 py-10 md:py-14">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-6 md:p-8 rounded-xl bg-white border border-tie-teal/20">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-tie-teal/10 flex items-center justify-center shrink-0">
                  <i className="ri-route-line text-tie-teal text-xl" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-tie-text-primary">
                    Continue the Innovation Pathway
                  </p>
                  <p className="text-sm text-tie-text-secondary">
                    After PIIC generates promising solutions, PTIM validates them before full-scale rollout.
                  </p>
                </div>
              </div>
              <Link
                to="/ptim"
                className="inline-flex items-center px-6 py-3 rounded-full bg-tie-teal text-white text-sm font-medium hover:bg-tie-teal-dark transition-all duration-300 whitespace-nowrap"
              >
                Explore PTIM
                <i className="ri-arrow-right-line ml-2" />
              </Link>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}